import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CarnivalService } from '../carnival-management/carnival.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-view-event',
  templateUrl: './view-event.component.html',
  styleUrls: ['./view-event.component.scss']
})
export class ViewEventComponent implements OnInit {
  constructor(private spinner:NgxSpinnerService,private carnivalService:CarnivalService) { }
  pageLimit:any
  loadingIndicator:any
  reorderable:any
  ngOnInit() {
    this.getEventList();
  }
  eventList:any;
  getEventList() {
    let query = '';
    // var queryValue = this.queryParams();
    this.spinner.show();
  this.carnivalService.getEventsListApi(query).subscribe(
    res => {
      this.spinner.hide();
      if ((res["message"] = "Success")) {
        this.eventList = res["data"]["eventList"];
      } else {
        this.eventList = [];
      }
      this.spinner.hide();
    },
    err => {
      this.spinner.hide();
    }
  );
  }
     searchBusinessFilters() {
    this.getEventList();
  }

  deleteEventAction(title,eventId) {
      Swal.fire({
        title: "You Want to delete: " + title,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          let query = eventId+ "?isAdmin=true"
          
          this.spinner.show();
          this.carnivalService.deleteEventApi(query).subscribe(
            res => {
              this.spinner.hide();
              if (res["message"] == "Success") {
                Swal.fire("Success", "Event deleted successfully!", "success");
              } else {
                Swal.fire("Error", res.data, "error");
              }
              this.spinner.hide();
              this.getEventList();
            },
            err => {
              this.spinner.hide();
            }
          );
        }
      });
    }
  
    showImageModal(image: any) {
      if (image) {
        Swal.fire({
          title: "Cover Image",
          imageUrl: image,
          imageHeight: 250,
          imageWidth: 250,
          customClass: {
            title: "title-class11"
          }
        });
      }
    }

    // onReset() {
    //   this.spinner.show();
    //   setTimeout(() => {
    //     /** spinner ends after 5 seconds */
    //     this.spinner.hide();
    //   }, 2000);
    //     (this.searchStartDate = ""),
    //     (this.searchEndDate = "");
    //   this.getCarnivalList();
    // }




}
